import React from 'react';

import type { Node } from './../../ricos-schema/legacy/wix/rich_content/v1';
import { Decoration_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { FontSizeDecoration, NodeViewDecorator } from './../../ricos-types';

const decorator = (element: JSX.Element, fontSizeDecoration: FontSizeDecoration) => {
  const { unit, value } = fontSizeDecoration.fontSizeData || {};
  return (
    <span
      key={`fontsize-${element.key}`}
      style={{ fontSize: `${value}${unit ? unit.toLowerCase() : 'px'}` }}
    >
      {element}
    </span>
  );
};

const FontSizeDecorator: NodeViewDecorator<JSX.Element> = {
  rule: (node: Node) =>
    !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.FONT_SIZE),
  decorate: ({ element, node }) => {
    const fontSizeDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.FONT_SIZE
    ) as FontSizeDecoration;
    return decorator(element as JSX.Element, fontSizeDecoration);
  },
};

export default FontSizeDecorator;
